import api from "./api";

const baseURL = process.env.REACT_APP_CORE_REGISTRY;

export async function list(text) {
    return await api.get(`${baseURL}/api/v1/transacoes-sistema?text=${text}`);
}

export async function update(data) {
    return await api.put(`${baseURL}/api/v1/transacoes-sistema`, data);
}

export async function get(id) {
    return await api.get(`${baseURL}/api/v1/transacoes-sistema/${id}`);
}

export async function filter(id) {
    return await api.get(`${baseURL}/api/v1/transacoes-sistema-filtrar?page=0`);
}
